import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// استيراد ملفات الترجمة
import en from "./locales/en.json";
import ar from "./locales/ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: "en", // اللغة الافتراضية
  fallbackLng: "en", // اللغة الاحتياطية
  interpolation: {
    escapeValue: false, // لا نحتاج إلى هروب النصوص
  },
});

export default i18n;
